import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  API_KEYS_CONTAINER: `${cleanedFilename(__filename)}-api-keys-container`,
  ADD_API_KEY_BUTTON: `${cleanedFilename(__filename)}-add-api-key-button`,
};
